<template>
  <v-row>
    <input
      id="trackUrl"
      style="position: absolute; left: -1000px; top: -1000px"
    >
    <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="!simplified"
          small
          color="blue"
          class="text-none"
          dark
          v-on="on"
        >
          Message Customer
        </v-btn>
        <v-btn
          v-else
          x-small
          text
          color="blue"
          class="text-none"
          dark
          @click="morePressed"
          v-on="on"
        >
          More
        </v-btn>
      </template>

      <v-list
        v-if="bookingForm != null"
        dense
        style="width: 256px"
      >
        <v-list-item
          v-if="showInvoice"
          class="text-none"
          small
          color="white"
          @click="gotoInvoice"
        >
          Invoice Details
        </v-list-item>
        <v-list-item
          v-if="bookingForm.booking.state == 'cancelled'"
          class="text-none"
          small
          color="white"
          @click="recover"
        >
          Recover
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="openCopyBooking"
        >
          Copy Booking
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="openReturnBooking"
        >
          Return Booking
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="copyPayLink"
        >
          Copy Pay Link
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="copyTrackLink"
        >
          Copy Track Link
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="showSendTrackLinkDialog"
        >
          Send Track Link (SMS)
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="showSendSMSDialog"
        >
          Send Message (SMS)
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="showSendCustomerConfirmationDialog"
        >
          Send Customer Confirmation Email
        </v-list-item>
        <v-list-item
          class="text-none"
          small
          color="white"
          @click="showSendSupplierConfirmationDialog"
        >
          Send Supplier Confirmation Email
        </v-list-item>
        <v-list-item
          v-if="repeatTripId"
          class="text-none"
          small
          color="white"
          @click="gotToRepeatService"
        >
          <v-icon small color="blue">
            mdi-open-in-new
          </v-icon>&nbsp;
          Repeat Service
        </v-list-item>
        <v-list-item
          v-if="
            bookingForm && bookingForm.booking.state != null &&
              bookingForm.booking.state != 'cancelled' &&
              bookingForm.booking.state != 'completed'
          "
          class="text-none"
          small
          color="white"
          @click="cancelDialog = true"
        >
          Cancel Booking
        </v-list-item>
        <v-list-item
          v-if="
            bookingForm && bookingForm.booking.state != null &&
              bookingForm.booking.state == 'unconfirmed'
          "
          class="text-none"
          small
          color="white"
          @click="confirmTrip"
        >
          Confirm Booking
        </v-list-item>
      </v-list>
      <div
        v-else
        style="height: 48px; width: 256px; background-color: white;"
      >
        <div style="padding-left: 9px; padding-top: 9px;" v-if="!noProgressBar">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="30"
          />
        </div>
      </div>
    </v-menu>
    <v-flex
      v-if="!simplified"
      px-1
    >
      <v-btn
        submit
        class="text-none"
        small
        color="white"
        target="_blank"
        :href="'/book?rebook=' + bookingForm.booking.id"
      >
        Copy
      </v-btn>
    </v-flex>
    <v-dialog
      v-model="trackDialog"
      width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Send Track Link (SMS)</span>
        </v-card-title>
        <v-layout
          column
          px-4
        >
          <v-text-field
            v-model="smsContactNumber"
            label="Contact Number"
          />
          <p
            v-if="smsError != null"
            style="color:red;"
          >
            {{ smsError }}
          </p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer />
          <v-btn
            class="text-none"
            text
            @click="trackDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-none"
            text
            @click="sendTrackURLMessage()"
          >
            Send Message
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          v-if="loadingSendSMS == true"
          indeterminate
          color="yellow darken-2"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="customSMSDialog"
      width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Send Custom SMS</span>
        </v-card-title>
        <v-layout
          column
          px-4
        >
          <v-textarea
            v-model="customMessage"
            placeholder="Your custom message"
          />
          <v-text-field
            v-model="smsContactNumber"
            label="Contact Number"
          />
          <p
            v-if="smsError != null"
            style="color:red;"
          >
            {{ smsError }}
          </p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer />
          <v-btn
            class="text-none"
            text
            @click="customSMSDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-none"
            text
            @click="sendCustomSMS()"
          >
            Send Message
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          v-if="loadingSendSMS == true"
          indeterminate
          color="yellow darken-2"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="supplierConfirmationDialog"
      width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Send Supplier Confirmation</span>
        </v-card-title>
        <v-layout
          column
          px-4
        >
          <v-text-field
            v-model="email"
            label="Email"
          />
          <v-text-field
            v-model="extraText"
            label="Extra Text"
          />
          <v-btn @click="copyCovidPrompt">
            Copy COVID Prompt
          </v-btn>
          <p
            v-if="smsError != null"
            style="color:red;"
          >
            {{ smsError }}
          </p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer />
          <v-btn
            class="text-none"
            text
            @click="supplierConfirmationDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-none"
            text
            @click="sendSupplierConfirmationEmail()"
          >
            Send Email
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          v-if="loadingSendSMS == true"
          indeterminate
          color="yellow darken-2"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="customerConfirmationDialog"
      width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Send Customer Confirmation</span>
        </v-card-title>
        <v-layout
          column
          px-4
        >
          <v-text-field
            v-model="email"
            label="Email"
          />
          <p
            v-if="smsError != null"
            style="color:red;"
          >
            {{ smsError }}
          </p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer />
          <v-btn
            class="text-none"
            text
            @click="customerConfirmationDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-none"
            text
            @click="sendConfirmationEmail()"
          >
            Send Email
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          v-if="loadingSendSMS == true"
          indeterminate
          color="yellow darken-2"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelDialog"
      persistent
      width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Cancel Booking</span>
        </v-card-title>
        <v-flex pa-4>
          <v-row>
            <v-flex
              shrink
            >
              <v-radio-group v-model="cancellationReason" row>
                <v-radio
                  label="I no longer need this trip"
                  :value="'I no longer need this trip'"
                />
                <v-radio
                  label="My driver asked me to cancel"
                  :value="'My driver asked me to cancel'"
                />
                <v-radio
                  label="Driver was too far away"
                  :value="'Driver was too far away'"
                />
                <v-radio
                  label="Driver was too early"
                  :value="'Driver was too early'"
                />
                <v-radio
                  label="No Driver available"
                  :value="'no driver available'"
                />
                <v-radio
                  label="Other"
                  :value="'other'"
                />
              </v-radio-group>
              <div>
                <v-col md="6">
                  <v-textarea
                    v-if="cancellationReason"
                    class="small-text-field"
                    label="Type cancellation reason"
                    placeholder=" "
                    :height="28"
                    flat
                    filled
                    outlined
                    dense
                    v-model="otherCancellationReason"
                  />
      
                </v-col>
              </div>
            </v-flex>
            <v-flex
              v-if="bookingForm && bookingForm.booking.card_payment_type == 'prepaid'"
              shrink
            >
              <v-radio-group v-model="cancellationFee">
                <v-radio
                  label="Use System Policy"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
                <v-radio
                  label="No"
                  :value="2"
                />
              </v-radio-group>
            </v-flex>
            <v-flex
              shrink
              pl-5
            >
              <v-checkbox
                v-if="bookingHasOtherTripToCancel"
                v-model="cancelOtherTrip"
                :label="'Cancel ' + nameForOtherTrip + ' trip'"
              />
            </v-flex>
          </v-row>
        </v-flex>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="cancelDialog = false"
          >
            Back
          </v-btn>
          <v-btn
            text
            @click="cancel"
          >
            Confirm Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "BookingActions",
  components: {
    SimpleTextAreaInput,
    BookTripETARoute
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    repeatTripId: {
      type: Number,
      default: null
    },
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false
    },
    largeMode: {
      type: Boolean,
      default: true
    },
    simplified: {
      type: Boolean,
      default: false
    },
    noProgressBar: {
      type: Boolean,
      default: false
    },
    showInvoice: {
      type: Boolean,
      default: false
    },
    invoiceId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      confirmBookingDialog: false,
      menu: false,
      cancelDialog: false,
      cancellationFee: false,
      cancellationReason: "",
      otherCancellationReason: "",
      cancelOtherTrip: false,
      trackDialog: false,
      customSMSDialog: false,
      loadingSendSMS: false,
      smsError: null,
      smsContactNumber: null,
      customMessage: "",
      supplierConfirmationDialog: false,
      customerConfirmationDialog: false,
      email: "",
      extraText: "",
    };
  },
  computed: {
    nameForOtherTrip: function () {
      if (this.bookingForm) {
        if (
            this.bookingForm.booking.cart.outboundBookingId ==
            this.bookingForm.booking.id
        ) {
          return "Return";
        } else {
          return "Outbound";
        }
      }
    },
    bookingHasOtherTripToCancel: function () {
      if (this.bookingForm) {
        if (this.bookingForm.booking.cart == null) {
          return false;
        }
        if (
            this.bookingForm.booking.cart.outboundBookingId ==
            this.bookingForm.booking.id
        ) {
          if (this.bookingForm.booking.cart.returnBookingId != null) {
            if (
                this.bookingForm.booking.cart.returnState != "completed" &&
                this.bookingForm.booking.cart.returnState != "cancelled"
            ) {
              return true;
            }
          }
        } else {
          if (
              this.bookingForm.booking.cart.outboundState != "completed" &&
              this.bookingForm.booking.cart.outboundState != "cancelled"
          ) {
            return true;
          }
        }
        return false;
      }
    },
  },
  methods: {
    confirmTrip () {
      this.$swal.fire({
        title: 'Are you sure you want to confirm this trip?',
        text: "This trip will be booked and you can assign to driver",
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: this.$colorsConfig.getUnconfirmedBookingColor(),
        cancelButtonColor: '#e85b5b',
        denyButtonColor: '#3085d6',
        confirmButtonText: 'Yes, confirm it!',
        denyButtonText: `Update Details`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('unconfirmedBooking/confirm', this.bookingForm.booking.id)
          this.$swal.fire(
            'Confirmed!',
            'The trip is now booked for customer',
            'success'
          )
          this.$emit('bookingConfirmed')
        } else if (result.isDenied) {
          // this.$swal.fire('Please update the trip details. When you press update, it will be confirmed', '', 'info')
          this.$store.commit('unconfirmedBooking/setUnconfirmedUpdate', true)
          this.goToBooking(this.bookingForm.booking.id)
        }
      })
    },
    gotToRepeatService() {
      return window.open('/repeat_service/edit/' + this.repeatTripId , '_blank')
    },
    gotoInvoice() {
      if (this.invoiceId) {
        let invoicePath = 'invoices/' + this.invoiceId
        window.open(invoicePath)
      }
    },
    goToBooking(bookingId) {
        let bookingPath = 'bookings/' + bookingId + "?unconfirmed-edit=true"
        window.open(bookingPath)
    },
    cancel: function () {
      let params = {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
        cancellationReason: this.cancellationReason,
        otherCancellationReason:this.otherCancellationReason,
      }
  
      if (!this.cancellationReason) {
        this.$snackbar.error("Please select cancellation reason")
        return;
      }
      if (!this.otherCancellationReason) {
        this.$snackbar.error("Please type cancellation reason")
        return;
      }
  
      this.cancelDialog = false;
  
      this.$emit("cancel", {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
      });
      this.bookingForm.cancelRide(this.cancelledBooking, params)
      // Promise.resolve(this.bookingForm.cancelRide(this.cancelledBooking(), params)).then(this.emitBookingCancelled())
    },
    emitBookingCancelled () {
      this.$emit('bookingCancelled', true)
    },
    cancelledBooking: function () {
      this.$emit("cancelledBooking", null);
    },
    recover: function(booking) {
      console.log("Recover called");

      var booking = this.bookingForm.booking;

      var url = `${this.$store.state.apiUrl}/booking/recover/${booking.id}?manual_dispatch=false`;

      var vm = this;
      
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {

          if (res.data.error == "no_error") {
            console.log("Recovered trip");
            booking.state = 'booked';
            vm.$emit('reload')
          } else {
            alert("Failed to recover booking");
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    morePressed: function() {
      this.$emit("morePressed")
    },
    copyCovidPrompt: function() {
      this.extraText = "You will need to do a Lateral Flow test, 1 day prior to the journey and produce a negative test. Keep hold of the results as you may need to show this at the port.<br><br>You will also be required to retest at the port when dropping your passengers. Order test here: https://www.gov.uk/order-coronavirus-rapid-lateral-flow-tests<br><br>Please log on to the app 1 hr prior to your journey commencing.<br><br>Shirt, trousers and tie are a must. The vehicle must be immaculate internally and externally.<br><br>PORT PROCEDURES<br><br>You'll need to check in at Horizon Cruise Terminal 15 minutes before your pickup time. The team will provide you a TAG which will permit you access to collect your customers.<br><br>Then proceed to city cruise terminal for passenger collection.<br><br>Dropping passengers to the port you will be required to carry out a lateral flow test."
    },
    copyTrackLink: function() {
      const el = document.getElementById("trackUrl");
      el.value = this.bookingForm.booking.track_booking_url;
      el.select();
      document.execCommand("copy");

      navigator.clipboard.writeText(this.bookingForm.booking.track_booking_url)

      console.log("Copied " + el.value);
    },
    openCopyBooking() {
      return window.open('book?rebook=' + this.bookingForm.booking.id)
    },
    openReturnBooking() {
      return window.open('book?rebook=' + this.bookingForm.booking.id + "&type=return")
    },
    copyPayLink: function() {
      const el = document.getElementById("trackUrl");
      el.value = this.bookingForm.booking.track_booking_url.replace("/track/", "/pay/");
      el.select();
      document.execCommand("copy");


      navigator.clipboard.writeText(this.bookingForm.booking.track_booking_url.replace("/track/", "/pay/"))

      console.log("Copied " + el.value);
    },
    showSendTrackLinkDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.trackDialog = true;
    },
    showSendCustomerConfirmationDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_email != null) {
        this.email = this.bookingForm.booking.business_customer_email;
      } else {
        this.email = this.bookingForm.user.email;
      }

      this.customerConfirmationDialog = true;
    },
    showSendSupplierConfirmationDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_email != null) {
        this.email = "";
      } else {
        this.email = "";
      }

      if (this.bookingForm.booking.preassigned_driver_email != null) {
        this.email = this.bookingForm.booking.preassigned_driver_email;
      }

      this.supplierConfirmationDialog = true;
    },
    showSendSMSDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.customSMSDialog = true;
    },
    sendTrackURLMessage: async function() {
      console.log("Sending Track URL");

      this.smsError = null;

      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendTrackURLMessage?booking_id=${
            this.bookingForm.booking.id
          }&contact_number=${this.smsContactNumber.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        if (response.data.error == "no_error") {
          this.trackDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendCustomSMS: async function() {
      console.log("Sending Track URL");

      this.smsError = null;
  
      var booking = this.bookingForm.booking;
  
      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/customMessageBooking?message=${
            this.customMessage
          }&contact_number=${this.smsContactNumber.trim()}&booking_id=${booking.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.customSMSDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendSupplierConfirmationEmail: async function() {
      console.log("Sending Supplier Confirmation Email");

      this.smsError = null;

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendSupplierConfirmation?booking_id=${
            this.bookingForm.booking.id
          }&email=${this.email.trim()}&extraText=${this.extraText}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.supplierConfirmationDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendConfirmationEmail: async function() {
      console.log("Sending Supplier Confirmation Email");

      this.smsError = null;

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendConfirmation?booking_id=${
            this.bookingForm.booking.id
          }&email=${this.email.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.customerConfirmationDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
